<dt-modal-content [contentPadding]="false" (closeClick)="close()" [flexContent]="true">
  <ng-template #title>
    <div class="header">
      <span>{{ event.name }}</span>
      <div
        #saveIndicator
        class="save-indicator"
        i18n-matTooltip
        matTooltip="Änderungen werden automatisch in Deinem Benutzerkonto gespeichert"
      >
        @switch (saveState) {
          @case ('saving') {
            <mat-icon>sync</mat-icon>
            <span i18n>Wird gespeichert&mldr;</span>
          }
          @default {
            <mat-icon>cloud_upload</mat-icon>
            @if (saveState === 'saved') {
              <span i18n>Erfolgreich gespeichert!</span>
            }
          }
        }
      </div>
    </div>
  </ng-template>
  <ng-template #content>
    <div class="modal-content">
      @if (!lastSaveSuccessful) {
        <div class="overlay" i18n
          >Beim Speichern Deiner Änderungen ist ein Problem aufgetreten. Möglicherweise ist Deine Internetverbindung instabil. Im
          Hintergrund wird weiterhin versucht die Änderungen zu speichern. Wenn Du diese Fenster schließt, gehen Deine Änderungen verloren.
          Wenn das Problem trotz stabiler Internetverbindung weiterhin besteht, wende Dich bitte an den Veranstalter, um Hilfe zu erhalten.
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </div>
      }

      @if (secondsSinceClose > 2 && lastSaveSuccessful) {
        <div class="overlay" i18n
          >Im Hintergrund werden noch Änderungen gespeichert. Achtung! Wenn Du dieses Fenster schließt, gehen alle nicht gespeicherten
          Änderungen verloren.
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </div>
      }

      <mat-tab-group mat-stretch-tabs="false" dynamicHeight #tabGroup>
        <mat-tab i18n-label label="Übersicht">
          <div class="overview-tab">
            @if (submitted) {
              <p i18n
                >Du hast für diese Veranstaltung am <span class="bold">{{ submission.updatedAt | date: 'short' }}</span> erfolgreich
                abgegeben.</p
              >
              <div class="project-action-buttons">
                <button
                  mat-raised-button
                  color="accent"
                  dtElementRef
                  #downloadProjectButton="dtElementRef"
                  [disabled]="isBusy"
                  [dtOverlayProgress]="isBusy"
                  (click)="downloadProject(downloadProjectButton)"
                  i18n
                  >Projekt herunterladen</button
                >
                <button
                  mat-raised-button
                  color="accent"
                  dtElementRef
                  #openProjectButton="dtElementRef"
                  [disabled]="isBusy"
                  (click)="openProject(submission.event.id, submission.id, openProjectButton)"
                  [dtOverlayProgress]="isBusy"
                  i18n
                  >Projekt öffnen</button
                >
              </div>
              <div class="mat-caption">
                <span i18n>Abgabe-ID: </span><span class="grey">{{ submission.id }}</span>
              </div>
            } @else {
              <div class="requirements">
                <div>
                  @if (projectLoaded) {
                    <div class="header" i18n>Projekt „{{ projectService.getProjectName() }}“</div>
                    @for (requirement of projectRequirements; track requirement; let requirementIndex = $index) {
                      @if (requirement[1]) {
                        <div class="requirement">
                          <ng-template #satisfiedText>
                            @switch (requirement[0]) {
                              @case ('requireDecisionQuality') {
                                <ng-container i18n>Entscheidungsqualität wurde bewertet</ng-container>
                              }
                              @default {
                                <ng-container i18n>Schritt {{ requirementIndex + 1 }} wurde bearbeitet</ng-container>
                              }
                            }
                          </ng-template>
                          <ng-template #unsatisfiedText>
                            @switch (requirement[0]) {
                              @case ('requireDecisionQuality') {
                                <ng-container i18n>Entscheidungsqualität wurde nicht bewertet</ng-container>
                              }
                              @default {
                                <ng-container i18n>Schritt {{ requirementIndex + 1 }} wurde nicht vollständig bearbeitet</ng-container>
                              }
                            }
                          </ng-template>
                          @if (requirement[2]) {
                            <span class="satisfied">
                              <mat-icon>check</mat-icon><ng-container *ngTemplateOutlet="satisfiedText"></ng-container>
                            </span>
                          } @else {
                            <span class="unsatisfied">
                              <mat-icon>close</mat-icon><ng-container *ngTemplateOutlet="unsatisfiedText"></ng-container>
                            </span>
                          }
                        </div>
                      }
                    }
                  } @else {
                    <div class="header" i18n>Projekt</div>
                    <div class="requirement">
                      <span class="unsatisfied">
                        <mat-icon>close</mat-icon>
                        <span i18n>Kein Projekt geladen</span>
                      </span>
                    </div>
                  }
                </div>
                @if (event.questionnaire == null) {
                  <div>
                    <div class="header" i18n>Fragebogen</div>
                    <div class="requirement">
                      <span class="unsatisfied">
                        <mat-icon>close</mat-icon>
                        <span i18n
                          >Der Fragebogen wurde vom Veranstalter noch nicht veröffentlicht. Bis der Veranstalter den Fragebogen freigibt,
                          kannst Du nicht abgeben.</span
                        >
                      </span>
                    </div>
                  </div>
                }
                @if (event.questionnaire?.length > 0) {
                  <div>
                    <div class="header" i18n>Fragebogen</div>
                    @if (questionnaireSatisfied) {
                      <div class="requirement">
                        <span class="satisfied">
                          <mat-icon>check</mat-icon><span i18n>Alle Fragen des Fragebogens wurden beantwortet</span>
                        </span>
                      </div>
                    } @else {
                      <div class="requirement">
                        <span class="unsatisfied"><mat-icon>close</mat-icon><span i18n>Der Fragebogen ist unvollständig</span></span>
                      </div>
                    }
                  </div>
                }
                @if (event.freeTextConfig.enabled) {
                  <div>
                    <div class="header">{{ event.freeTextConfig.name }}</div>
                    @if (freeTextSatisfied) {
                      <div class="requirement">
                        <span class="satisfied">
                          <mat-icon>check</mat-icon>
                          <span i18n>Die Mindestanforderung von {{ event.freeTextConfig.minLength }} Zeichen ist erfüllt</span>
                        </span>
                      </div>
                    } @else {
                      <div class="requirement">
                        <span class="unsatisfied">
                          <mat-icon>close</mat-icon>
                          <span i18n>Die Mindestanforderung von {{ event.freeTextConfig.minLength }} Zeichen ist nicht erfüllt</span>
                        </span>
                      </div>
                    }
                  </div>
                }
                <div>
                  <div class="header" i18n>Abgabefrist</div>
                  @if (startDateReached && !pastEndDate) {
                    <div class="requirement">
                      <span class="satisfied">
                        <mat-icon>check</mat-icon>
                        @if (event.endDate) {
                          <span i18n>Abgaben werden noch bis zum {{ event.endDate | date: 'short' }} akzeptiert</span>
                        } @else {
                          <span i18n>Abgaben werden fristlos akzeptiert</span>
                        }
                      </span>
                    </div>
                  }
                  @if (!startDateReached) {
                    <div class="requirement">
                      <span class="unsatisfied">
                        <mat-icon>close</mat-icon>
                        <span i18n>Abgaben werden erst ab dem {{ event.startDate | date: 'short' }} akzeptiert</span>
                      </span>
                    </div>
                  }
                  @if (pastEndDate) {
                    <div class="requirement">
                      <span class="unsatisfied">
                        <mat-icon>close</mat-icon>
                        <span i18n>Abgaben wurden nur bis zum {{ event.endDate | date: 'short' }} akzeptiert</span>
                      </span>
                    </div>
                  }
                </div>
                @if (this.event.requireDataUsageAuthorization) {
                  <div>
                    <div class="header" i18n>Datenverwendung</div>
                    <mat-checkbox
                      class="data-auth-checkbox"
                      [checked]="dataUsageAuthorized"
                      (change)="dataUsageAuthorized = $event.checked"
                      [class.authorized]="dataUsageAuthorized"
                    >
                      Ich stimme der Verwendung meiner Daten zu Forschungszwecken und zur Verbesserung des Tools zu.
                    </mat-checkbox>
                  </div>
                }
              </div>

              <div class="action-row">
                <button
                  #submitButton
                  mat-raised-button
                  color="accent"
                  (click)="submit()"
                  [disabled]="!submissionValid || isBusy"
                  [dtOverlayProgress]="isBusy"
                  i18n
                  >Projekt abgeben</button
                >
                <button
                  dtElementRef
                  #leaveButton="dtElementRef"
                  mat-raised-button
                  [disabled]="isBusy"
                  [dtOverlayProgress]="isBusy"
                  (click)="leaveEvent(leaveButton)"
                  i18n
                  >Veranstaltung verlassen</button
                >
              </div>
            }
          </div>
        </mat-tab>
        @if (event.questionnaire?.length > 0) {
          <mat-tab i18n-label label="Fragebogen" [disabled]="isBusy">
            <div class="questionnaire-tab">
              <dt-questionnaire
                [readonly]="submitted"
                [questionnairePages]="event.questionnaire"
                [submission]="submission"
                (isValid)="questionnaireSatisfied = $event"
                (openStatus)="tabGroup.selectedIndex = 0"
              ></dt-questionnaire>
            </div>
          </mat-tab>
        }
        @if (event.freeTextConfig.enabled) {
          <mat-tab [label]="event.freeTextConfig.name" [disabled]="isBusy">
            <dt-rich-text-editor
              [readonly]="submitted"
              [(text)]="freeTextContent"
              (textChange)="freeTextChange$.next()"
              [placeholder]="event.freeTextConfig.placeholder"
              (characterCountChange)="freeTextCharacterCount = $event"
            >
            </dt-rich-text-editor>
            @if (event.freeTextConfig.minLength) {
              <div class="free-text-character-counter">
                <span [class.warning]="freeTextCharacterCount < event.freeTextConfig.minLength">
                  {{ freeTextCharacterCount }} / {{ event.freeTextConfig.minLength }} <span i18n>Zeichen</span>
                </span>
              </div>
            }
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </ng-template>
</dt-modal-content>
